{
  "nav": {
    "calendaris": "Calendarios",
    "canvisTorn": "Cambios de turno",
    "cobertura": "Cobertura",
    "experts": "Expertos y sustitutos",
    "historial": "Historial",
    "guardiaActual": "Guardia actual"
  },
  "titols": {
    "calendaris": "Calendarios de guardia",
    "canvisTorn": "Solicitudes de cambio de turno",
    "cobertura": "Cobertura y huecos",
    "experts": "Expertos y sustitutos por servicio",
    "historial": "Historial de cambios · Calendarios",
    "guardiaActual": "Quién está de guardia",
    "editor": "Editor de calendario"
  },
  "comu": {
    "cancella": "Cancelar",
    "exporta": "Exportar",
    "carregant": "Cargando…",
    "i": "y",
    "torna": "Volver",
    "desa": "Guardar",
    "edita": "Editar"
  },
  "calendaris": {
    "nou": "Nuevo calendario",
    "duplica": "Duplicar",
    "copiaDe": "Copia de {{nom}}",
    "crea": "Crear calendario",
    "nom": "Nombre del calendario",
    "triaAmbit": "Elige departamento o área",
    "totDepartament": "{{nom}} (todo el departamento)",
    "cerca": "Buscar calendario…",
    "total_one": "{{count}} calendario",
    "total_other": "{{count}} calendarios",
    "buit": "No hay calendarios",
    "manual": "Manual",
    "recordatoriHores_one": "{{count}} h antes",
    "recordatoriHores_other": "{{count}} h antes",
    "area": "Área {{nom}}",
    "departament": "Departamento {{nom}}",
    "origen": "Calendario de origen",
    "triaOrigen": "Elige el calendario a duplicar"
  },
  "columnes": {
    "calendari": "Calendario",
    "ambit": "Ámbito",
    "rotacio": "Tipo de rotación",
    "persones": "Personas",
    "cobertura30": "Cobertura 30 días",
    "estat": "Estado",
    "recordatori": "Recordatorio"
  },
  "periodicitat": {
    "SETMANAL": "Semanal",
    "QUINZENAL": "Quincenal",
    "MENSUAL": "Mensual"
  },
  "estatCalendari": {
    "ACTIU": "Activo",
    "BUITS": "Huecos detectados",
    "INSUFICIENT": "Cobertura insuficiente",
    "INACTIU": "Inactivo",
    "REVISIO": "En revisión"
  },
  "torn": {
    "nou": "Nuevo turno",
    "editar": "Editar turno",
    "elimina": "Eliminar el turno",
    "desa": "Guardar el turno",
    "calendari": "Calendario",
    "inici": "Fecha y hora de inicio",
    "fi": "Fecha y hora de fin",
    "titular": "Persona titular",
    "substitut": "Persona de sustitución",
    "triaPersona": "Elige una persona",
    "senseSubstitut": "Sin sustituto",
    "canals": "Canales de contacto",
    "notes": "Notas",
    "avis": "Se avisará automáticamente a {{persones}} al guardar los cambios.",
    "ambit": "Ámbito"
  },
  "canals": {
    "PUSH": "Push",
    "EMAIL": "Correo",
    "TRUCADA": "Llamada"
  },
  "editor": {
    "senseCobertura": "Sin cobertura",
    "buit": "Vacío",
    "rotacio": "Rotación automática",
    "desa_one": "Guardar {{count}} cambio",
    "desa_other": "Guardar {{count}} cambios",
    "anterior": "Semana anterior",
    "seguent": "Semana siguiente",
    "periode": "{{desde}} — {{fins}}",
    "avui": "Volver a la semana actual",
    "persona": "Persona",
    "tornDia": "Turno del día",
    "lletraTitular": "T",
    "lletraSubstitut": "S",
    "disponibles": "Personas disponibles",
    "ajuda": "Arrastra una persona sobre una casilla para cubrir el turno, o selecciónala y haz clic en el día. Si el día ya tiene titular, se asigna como sustituto.",
    "cercaPersona": "Buscar persona",
    "afegeix": "Añadir {{nom}}",
    "periodeEtiqueta": "Periodo de la cuadrícula",
    "recarrega": "Recargar",
    "graella": "Cuadrícula de turnos",
    "senseTorns": "No hay turnos en este periodo",
    "ambTorns_one": "{{count}} turno en el periodo",
    "ambTorns_other": "{{count}} turnos en el periodo",
    "senseTorn": "{{area}} · Sin turno asignado"
  },
  "llegenda": {
    "titular": "Titular",
    "substitut": "Sustituto",
    "crisi": "Refuerzo en crisis",
    "senseCobertura": "Sin cobertura"
  },
  "diesCurts": {
    "0": "L",
    "1": "M",
    "2": "X",
    "3": "J",
    "4": "V",
    "5": "S",
    "6": "D"
  },
  "diesLlargs": {
    "0": "Lunes",
    "1": "Martes",
    "2": "Miércoles",
    "3": "Jueves",
    "4": "Viernes",
    "5": "Sábado",
    "6": "Domingo"
  },
  "rotacio": {
    "titol": "Nueva rotación automática · {{nom}}",
    "configuracio": "Configuración",
    "periodicitat": "Tipo de repetición",
    "desde": "Fecha de inicio de vigencia",
    "fins": "Fecha de fin de vigencia",
    "senseFi": "Sin fecha de fin",
    "diaInici": "Día de cambio de turno",
    "horaCanvi": "Hora de inicio de turno",
    "participants_one": "Participantes ({{count}})",
    "participants_other": "Participantes ({{count}})",
    "ajudaOrdre": "Arrastra para cambiar el orden. Cada persona será titular un periodo y sustituta el siguiente.",
    "senseParticipants": "Añade al menos una persona",
    "puja": "Subir {{nom}}",
    "pujaCurt": "↑",
    "baixa": "Bajar {{nom}}",
    "baixaCurt": "↓",
    "treu": "Quitar {{nom}}",
    "treuCurt": "✕",
    "previsualitzacio": "Previsualización",
    "genera": "Generar y previsualizar",
    "confirma": "Confirmar y aplicar",
    "resum_one": "Se generará {{count}} turno.",
    "resum_other": "Se generarán {{count}} turnos.",
    "conflictes_one": "{{count}} solapamiento con turnos existentes",
    "conflictes_other": "{{count}} solapamientos con turnos existentes",
    "mes_one": "… y {{count}} turno más",
    "mes_other": "… y {{count}} turnos más",
    "ajudaPrevi": "Configura la rotación y genera una previsualización antes de aplicarla.",
    "pas1": "1 · Frecuencia y vigencia",
    "pas2_one": "2 · Orden de rotación de personas ({{count}})",
    "pas2_other": "2 · Orden de rotación de personas ({{count}})",
    "titularDe": "Titular · {{nom}}",
    "tornsGenerats": "Turnos generados",
    "conflictesDetectats": "Conflictos detectados",
    "cap": "Ninguno"
  },
  "sollicituds": {
    "pendents_one": "{{count}} pendiente",
    "pendents_other": "{{count}} pendientes",
    "totes": "Todas",
    "cerca": "Buscar solicitud…",
    "buit": "No hay solicitudes",
    "tria": "Selecciona una solicitud",
    "detall": "Solicitud #{{id}}",
    "sollicitant": "Solicitante",
    "tipus": "Tipo",
    "tornAfectat": "Turno afectado",
    "proposat": "Persona propuesta",
    "novaFranja": "Nueva franja",
    "motiu": "Motivo",
    "data": "Fecha de la solicitud",
    "comentari": "Comentario",
    "ambConflictes_one": "La cobertura resultante tiene {{count}} solapamiento.",
    "ambConflictes_other": "La cobertura resultante tiene {{count}} solapamientos.",
    "senseConflictes": "Sin conflictos: {{nom}} no tiene ningún otro turno asignado esos días.",
    "denega": "Denegar",
    "aprova": "Aprobar el cambio",
    "titolTipus": {
      "CANVI": "{{nom}} solicita un cambio de horario",
      "SUBSTITUCIO": "{{nom}} solicita sustitución",
      "INTERCANVI": "{{nom}} solicita un intercambio"
    },
    "sollicitatEl": "Solicitado el {{data}}",
    "titularActual": "Titular actual",
    "substitutActual": "Persona del turno",
    "coberturaResultant": "Cobertura resultante",
    "comentariOpcional": "Comentario (opcional)",
    "comentariPlaceholder": "Añade un comentario para el historial…"
  },
  "estatSollicitud": {
    "PENDENT": "Pendiente",
    "APROVADA": "Aprobada",
    "REBUTJADA": "Denegada",
    "CANCELLADA": "Cancelada"
  },
  "tipusSollicitud": {
    "CANVI": "Cambio de horario",
    "SUBSTITUCIO": "Sustitución",
    "INTERCANVI": "Intercambio"
  },
  "cobertura": {
    "per": {
      "DEPARTAMENT": "Por departamento",
      "AREA": "Por área"
    },
    "mitjana": "Cobertura media",
    "calendaris": "Calendarios",
    "buits": "Huecos detectados",
    "diesSense": "Días sin cobertura",
    "mapa": "Mapa de calor · próximos {{dies}} días",
    "buit": "No hay calendarios para mostrar",
    "alertes_one": "Alertas de cobertura",
    "alertes_other": "Alertas de cobertura",
    "senseAlertes": "No hay huecos de cobertura",
    "resol": "Abrir el calendario",
    "ambit": "Ámbito",
    "ajustat_one": "Cobertura ajustada el día {{dies}}.",
    "ajustat_other": "Cobertura ajustada los días {{dies}}.",
    "senseTitular": "Sin titular:"
  },
  "nivellCobertura": {
    "COBERT": "Cubierto",
    "AJUSTAT": "Ajustado",
    "SENSE": "Sin cobertura"
  },
  "experts": {
    "cerca": "Buscar servicio…",
    "total_one": "{{count}} servicio",
    "total_other": "{{count}} servicios",
    "buit": "No hay servicios",
    "servei": "Servicio",
    "area": "Área responsable",
    "titular": "Técnico experto",
    "substitut": "Sustituto",
    "circuit": "Circuito de escalado",
    "confirmacio": "Confirmación",
    "senseExpert": "Sin experto",
    "senseSubstitut": "Sin sustituto",
    "perDefecte": "Por defecto",
    "circuitDefecte": "Circuito por defecto",
    "edita": "Editar expertos de {{servei}}",
    "especialitat": "Especialidad",
    "igual": "Una persona no puede aparecer dos veces en la lista.",
    "minuts_one": "{{count}} min",
    "minuts_other": "{{count}} min",
    "mes_one": "+{{count}}",
    "mes_other": "+{{count}}",
    "nouServei": "Nuevo servicio",
    "senseExperts": "Este servicio aún no tiene ningún técnico experto.",
    "persona": "Persona {{n}}",
    "tipusFila": "Rol de la persona {{n}}",
    "treu": "Quitar la persona {{n}}",
    "afegeixTitular": "Añadir técnico experto",
    "afegeixSubstitut": "Añadir sustituto",
    "calTitular": "Se necesita al menos un técnico experto titular."
  },
  "historial": {
    "data": "Fecha y hora",
    "autor": "Autor",
    "torn": "Turno afectado",
    "anterior": "Valor anterior",
    "nou": "Valor nuevo",
    "motiu": "Motivo",
    "sistema": "Sistema",
    "tots": "Todos los calendarios",
    "equip": "Solo mi equipo",
    "total_one": "{{count}} cambio",
    "total_other": "{{count}} cambios",
    "buit": "No hay cambios registrados",
    "filtreCalendari": "Calendario: todos"
  },
  "accioHistorial": {
    "CREAR": "Creación",
    "MODIFICAR": "Modificación",
    "ELIMINAR": "Eliminación",
    "ROTACIO": "Rotación automática",
    "CANVI_APROVAT": "Cambio aprobado"
  },
  "guardia": {
    "instant": "Actualizado {{hora}}",
    "buit": "No hay guardias configuradas",
    "area": "Área",
    "tecnic": "Técnico de guardia",
    "cobertura": "Cobertura",
    "senseTecnic": "Sin técnico de guardia",
    "substitut": "Sustituto: {{nom}}",
    "senseSubstitut": "Sin sustituto",
    "fins": "hasta {{hora}}",
    "coberta": "Cubierta",
    "senseCobertura": "Sin cobertura"
  },
  "tipusRotacio": {
    "SETMANAL": "Semanal rotativa",
    "QUINZENAL": "Quincenal rotativa",
    "MENSUAL": "Mensual por turnos fijos",
    "MANUAL": "Turnos manuales"
  }
}
